/*
 * @Author: sunxiaohui
 */

import { notification } from './store.js'

export function trigger(msg, type, timeout) {
    notification.set({ type, msg, timeout })
}

export function show(msg, timeout) {
    trigger(msg, 'default', timeout)
}

export function danger(msg, timeout) {
    trigger(msg, 'danger', timeout)
}

export function warning(msg, timeout) {
    trigger(msg, 'warning', timeout)
}

export function info(msg, timeout) {
    trigger(msg, 'info', timeout)
}

export function success(msg, timeout) {
    trigger(msg, 'success', timeout)
}